import httpStore from "./httpStore";

/**
 * Get all carrier services
 * @returns {Promise<Object>} API response with carrier services data
 */
export async function getCarrierServices() {
  try {
    const response = await httpStore.get("/carriers/services");
    return response.data;
  } catch (error) {
    console.error("Error fetching carrier services:", error);
    throw error;
  }
}

/**
 * Update carrier service settings
 * @param {Object} serviceData - The service data to update
 * @param {string} serviceData.uuid - Service UUID
 * @param {boolean} serviceData.nkrEnabled - NKR enabled status
 * @param {boolean} serviceData.webSelfServiceEnabled - Web self service enabled status
 * @param {boolean} serviceData.specialOrderEnabled - Special order enabled status
 * @returns {Promise<Object>} API response
 */
export async function updateCarrierService(serviceData) {
  try {
    const response = await httpStore.put(
      `/carriers/services/${serviceData.uuid}`,
      {
        nkrEnabled: serviceData.nkrEnabled,
        webSelfServiceEnabled: serviceData.webSelfServiceEnabled,
        specialOrderEnabled: serviceData.specialOrderEnabled
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating carrier service:", error);
    throw error;
  }
}

/**
 * Update carriers and services from ShipStation
 * @returns {Promise<Object>} API response
 */
export async function updateCarriersAndServicesFromShipStation() {
  try {
    const response = await httpStore.get(
      "/shipping/update_carriers_and_services"
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating carriers and services from ShipStation:",
      error
    );
    throw error;
  }
}
